if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// MOBILE INFINITE SCROLL - Fixed loop detection

if (document.body.classList.contains('body-product-v-2-0')) {
  document.addEventListener('DOMContentLoaded', function() {
    // Only run on mobile
    if (window.innerWidth >= 750) return;
    
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    const slider = mediaGallery.querySelector('.product__media-list');
    if (!slider) return;

    // Get only original slides
    const originalSlides = Array.from(slider.querySelectorAll('.product__media-item:not(.clone)'));
    const totalSlides = originalSlides.length;
    
    if (totalSlides <= 2) return;

    // Hide extra dots
    const allDots = mediaGallery.querySelectorAll('.slider-counter__link--dots');
    allDots.forEach((dot, index) => {
      if (index >= totalSlides) {
        dot.style.display = 'none';
      }
    });

    let allSlides = [];
    let isJumping = false;

    // Setup infinite scroll - clone ALL items twice
    function setupInfiniteScroll() {
      // Remove existing clones
      slider.querySelectorAll('.clone').forEach(clone => clone.remove());

      // Clone all items and append to the end
      originalSlides.forEach(function(item) {
        const clone = item.cloneNode(true);
        clone.classList.add('clone');
        clone.removeAttribute('id');
        clone.removeAttribute('data-media-id');
        slider.appendChild(clone);
      });
      
      // Clone all items again and prepend to the beginning
      for (let i = originalSlides.length - 1; i >= 0; i--) {
        const clone = originalSlides[i].cloneNode(true);
        clone.classList.add('clone');
        clone.removeAttribute('id');
        clone.removeAttribute('data-media-id');
        slider.insertBefore(clone, slider.firstChild);
      }
      
      allSlides = Array.from(slider.querySelectorAll('.product__media-item'));
      
      // Start at the first set of original items - NO ANIMATION
      const startSlide = allSlides[totalSlides];
      slider.style.scrollBehavior = 'auto';
      slider.scrollLeft = startSlide.offsetLeft;
      
      // Re-enable smooth after positioning
      setTimeout(() => {
        slider.style.scrollBehavior = 'smooth';
      }, 50);
    }

    setupInfiniteScroll();

    function getSlideWidth() {
      return allSlides[0] ? allSlides[0].offsetWidth : 0;
    }

    function getCurrentIndex() {
      const slideWidth = getSlideWidth();
      if (slideWidth === 0) return totalSlides;
      return Math.round(slider.scrollLeft / slideWidth);
    }

    function getRealSlideNumber(index) {
      // Structure: [7 clones, 7 originals, 7 clones]
      // Indices:   [0-6,      7-13,       14-20]
      // We want to map to: 1-7 (real slide numbers)
      
      if (index < totalSlides) {
        // In start clones (0-6) - these represent slides 1-7
        return index + 1;
      } else if (index < totalSlides * 2) {
        // In originals (7-13) - map to 1-7
        return (index - totalSlides) + 1;
      } else {
        // In end clones (14-20) - these represent slides 1-7
        return (index - totalSlides * 2) + 1;
      }
    }

    function checkLoop() {
      if (isJumping) return;
      
      const currentIdx = getCurrentIndex();
      
      console.log('🔄 Check loop:', {
        currentIdx,
        totalSlides,
        inStartClones: currentIdx < totalSlides,
        inEndClones: currentIdx >= totalSlides * 2,
        scrollLeft: slider.scrollLeft,
        slideWidth: getSlideWidth()
      });
      
      // If scrolled to or past the last set of clones
      // Structure: [0-6 = start clones, 7-13 = originals, 14-20 = end clones]
      if (currentIdx >= totalSlides * 2) {
        isJumping = true;
        console.log('✅ In END clones, jumping back...');
        
        // Which end clone are we on? (0 = first end clone)
        const cloneOffset = currentIdx - (totalSlides * 2);
        // Jump to equivalent original (7-13)
        const targetIndex = totalSlides + cloneOffset;
        
        console.log('  From index', currentIdx, '→ to index', targetIndex);
        
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = allSlides[targetIndex].offsetLeft;
        
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(() => {
          slider.style.scrollBehavior = 'smooth';
          isJumping = false;
          updateDots();
        });
        return;
      }
      
      // If scrolled to or before the first set of clones
      if (currentIdx < totalSlides) {
        isJumping = true;
        console.log('✅ In START clones, jumping forward...');
        
        // Which start clone are we on? (0-6)
        const cloneOffset = currentIdx;
        // Jump to equivalent original (7-13)
        const targetIndex = totalSlides + cloneOffset;
        
        console.log('  From index', currentIdx, '→ to index', targetIndex);
        
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = allSlides[targetIndex].offsetLeft;
        
        // Use requestAnimationFrame for smoother transition
        requestAnimationFrame(() => {
          slider.style.scrollBehavior = 'smooth';
          isJumping = false;
          updateDots();
        });
        return;
      }
      
      console.log('👍 In originals, no jump needed');
    }

    function updateDots() {
      if (isJumping) return;
      
      const currentIdx = getCurrentIndex();
      const realNum = getRealSlideNumber(currentIdx);
      
      const dots = mediaGallery.querySelectorAll('.slider-counter__link--dots');
      dots.forEach((dot, index) => {
        if (index < totalSlides) {
          if (index === realNum - 1) {
            dot.classList.add('slider-counter__link--active');
          } else {
            dot.classList.remove('slider-counter__link--active');
          }
        }
      });
    }

    // Monitor native scroll with multiple triggers
    let scrollTimeout;
    let lastScrollLeft = -1;
    
    slider.addEventListener('scroll', function() {
      if (isJumping) return;
      
      clearTimeout(scrollTimeout);
      
      // Update dots during scroll
      updateDots();
      
      // Check for loop after scroll settles - TRY IMMEDIATELY TOO
      const currentScrollLeft = slider.scrollLeft;
      
      // Immediate check (for when snap stops scrolling)
      if (lastScrollLeft !== currentScrollLeft) {
        lastScrollLeft = currentScrollLeft;
        scrollTimeout = setTimeout(() => {
          checkLoop();
        }, 150); // Reduced to 150ms for faster response
      }
    }, { passive: true });

    // ALSO check on scrollend event (better support)
    slider.addEventListener('scrollend', function() {
      console.log('📌 Scrollend event fired');
      checkLoop();
    }, { passive: true });

    // ALSO check on touchend (for swipes)
    slider.addEventListener('touchend', function() {
      setTimeout(() => {
        console.log('👆 Touch ended, checking...');
        checkLoop();
      }, 250);
    }, { passive: true });

    // Arrow buttons
    const prevButton = mediaGallery.querySelector('.slider-button--prev.media-gallery-arrows');
    const nextButton = mediaGallery.querySelector('.slider-button--next.media-gallery-arrows');

    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (isJumping) return;
        
        const currentIdx = getCurrentIndex();
        const targetSlide = allSlides[currentIdx - 1];
        if (targetSlide) {
          slider.scrollTo({
            left: targetSlide.offsetLeft,
            behavior: 'smooth'
          });
          
          // Check after arrow click animation
          setTimeout(checkLoop, 400);
        }
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (isJumping) return;
        
        const currentIdx = getCurrentIndex();
        const targetSlide = allSlides[currentIdx + 1];
        if (targetSlide) {
          slider.scrollTo({
            left: targetSlide.offsetLeft,
            behavior: 'smooth'
          });
          
          // Check after arrow click animation
          setTimeout(checkLoop, 400);
        }
      });
    }

    // Dot clicks
    const dots = Array.from(mediaGallery.querySelectorAll('.slider-counter__link--dots'));
    dots.forEach((dot, index) => {
      if (index < totalSlides) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          if (isJumping) return;
          
          // Jump to the original slide (not clone)
          const targetIndex = totalSlides + index;
          const targetSlide = allSlides[targetIndex];
          if (targetSlide) {
            slider.scrollTo({
              left: targetSlide.offsetLeft,
              behavior: 'smooth'
            });
          }
        });
      }
    });

    // Initial update
    setTimeout(() => {
      updateDots();
    }, 200);
    
    console.log('🚀 Infinite scroll initialized:', {
      totalSlides,
      totalWithClones: allSlides.length,
      structure: `[${totalSlides} clones | ${totalSlides} originals | ${totalSlides} clones]`,
      indices: `[0-${totalSlides-1} | ${totalSlides}-${totalSlides*2-1} | ${totalSlides*2}-${totalSlides*3-1}]`
    });
  });
}

// V17



